module.exports = __webpack_public_path__ + "img/ice-mountain.1b850ed2.png";